import { render } from "./SearchBox.vue?vue&type=template&id=9946962e&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=9946962e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9946962e"],['__file',"src/views/ServiceCenter/components/SearchBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9946962e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9946962e', __exports__)) {
    api.reload('9946962e', __exports__)
  }
  
  module.hot.accept("./SearchBox.vue?vue&type=template&id=9946962e&scoped=true", () => {
    api.rerender('9946962e', render)
  })

}


export default __exports__